module.exports = __webpack_public_path__ + "fonts/Barlow-Light.19f244e.ttf";